import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { zh } from "./locales/zh";
import { en } from "./locales/en";

export const supportedLngs = ["zh", "en"] as const;
export type Lng = (typeof supportedLngs)[number];

export const resources = { zh, en };

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "zh",
    supportedLngs: [...supportedLngs],
    load: "languageOnly", // zh-CN / en-US 归一到 zh / en
    defaultNS: "common",
    interpolation: { escapeValue: false }, // React 已做 XSS 转义
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "fv-lang",
      caches: ["localStorage"],
    },
  });

// 同步 <html lang>，利于无障碍与 SEO。
function syncHtmlLang(lng: string) {
  document.documentElement.lang = lng.startsWith("en") ? "en" : "zh";
}
syncHtmlLang(i18n.resolvedLanguage ?? "zh");
i18n.on("languageChanged", syncHtmlLang);

export default i18n;
